import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ForbiddenComponent } from './forbidden.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';

const materialModules = [MatCardModule, MatProgressSpinnerModule, MatButtonModule];

@NgModule({
  declarations: [ForbiddenComponent],
  exports: [],
  imports: [
    CommonModule,
    // MaterialModule,
    SharedModule,
    ...materialModules,
  ],
})
export class ForbiddenModule {}
